import { faCircleDot } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { Column } from "../columns";
import { ThemeContext } from "../theme/ThemeContext";
import "./UserDataMobile.scss";

const UserDataMobile = ({ data }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="columns is-mobile mt-4 is-centered ">
        <div className="column is-10 is-centered">
          <div
            style={{
              padding: "0.75rem",
              paddingTop: "1.5rem",
              paddingBottom: "1.5rem",
            }}
          >
            <div>
              <div className="card cardStyle">
                <div className="card-content">
                  <Column className="has-text-centered">
                    {
                      <p
                        style={{ borderBottom: "1px solid #ccc" }}
                        className="headers-mobile is-size-4"
                      >
                        OPĆI PODACI:{" "}
                      </p>
                    }
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Ime: </p>}
                    {data?.generalInfo?.ime}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Prezime: </p>}
                    {data?.generalInfo?.prezime}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Adresa stanovanja: </p>}
                    {data?.generalInfo?.adresa}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Mjesto stanovanja: </p>}
                    {data?.generalInfo?.mjesto}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Telefon: </p>}
                    {data?.generalInfo?.telefon}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Mobitel: </p>}
                    {data?.generalInfo?.mobitel}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">e-mail: </p>}
                    {data?.generalInfo?.email}
                  </Column>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div className="columns is-mobile mt-4 is-centered ">
        <div className="column is-10 is-centered">
          <div
            style={{
              padding: "0.75rem",
              paddingTop: "1.5rem",
              paddingBottom: "1.5rem",
            }}
          >
            <div>
              <div className="card cardStyle">
                <div className="card-content">
                  <Column className="has-text-centered">
                    {
                      <p
                        style={{ borderBottom: "1px solid #ccc" }}
                        className="headers-mobile is-size-4"
                      >
                        PODACI O LICENCI:
                      </p>
                    }
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Vrijedi od-do: </p>}
                    {data?.licenceInfo?.razdoblje}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Kategorija: </p>}
                    {data?.licenceInfo?.kategorija}
                  </Column>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Card 3 */}
      <div className="columns is-mobile mt-4 is-centered ">
        <div className="column is-10 is-centered">
          <div
            style={{
              padding: "0.75rem",
              paddingTop: "1.5rem",
              paddingBottom: "1.5rem",
            }}
          >
            <div>
              <div className="card cardStyle">
                <div className="card-content">
                  <Column className="has-text-centered">
                    {
                      <p
                        style={{ borderBottom: "1px solid #ccc" }}
                        className="headers-mobile is-size-4"
                      >
                        PODACI O ZAPOSLENJU:
                      </p>
                    }
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Podružnica: </p>}
                    {data?.employmentInfo?.podruznica}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Ustanova zaposlenja: </p>}
                    {data?.employmentInfo?.ustanova}
                  </Column>
                  <Column className="has-text-left">
                    {<p className="headers-mobile">Područje djelatnosti: </p>}
                    {data?.employmentInfo?.djelatnost}
                  </Column>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDataMobile;
